import FilterAppointments from "./FilterAppointments";

export default FilterAppointments;